<template>
  <div class="app-wrapper">
    <header class="top-header">
      <div class="header-brand">
        <div class="brand-mark">T</div>
        <div class="brand-info">
          <span class="brand-name">thxily</span>
          <span class="brand-sub">感謝一覧</span>
        </div>
      </div>
      <div class="header-actions">
        <button class="back-btn" v-on:click="$router.push('/menu')">← メニューへ戻る</button>
        <button class="logout-btn" v-on:click="logout">ログアウト</button>
      </div>
    </header>

    <main class="main-content">
      <div class="white-card">
        <div class="page-head">
          <div>
            <p class="page-kicker">THX activity feed</p>
            <h1 class="page-title">ありがとう一覧</h1>
          </div>
          <div class="page-summary">
            <span class="summary-label">表示件数</span>
            <span class="summary-value">{{ thanks.length }}</span>
          </div>
        </div>

        <div v-if="thanks.length > 0" class="post-list">
          <article v-for="thank in thanks" :key="thank.id" class="post-card">
            <div class="post-card__main">
              <div class="post-card__head">
                <div class="post-card__meta">
                  <span class="post-date">{{ thank.issue_date }}</span>
                  <span class="post-flow">{{ thank.from_name }} から {{ thank.to_name }} へ</span>
                </div>
                <div class="post-card__tools">
                  <div class="comment-count">
                    <span class="comment-count__label">コメント</span>
                    <span class="comment-count__value">{{ thank.comment_count }}</span>
                  </div>
                  <router-link
                    :to="'/comments/' + thank.id"
                    target="_blank"
                    class="secondary-link"
                  >
                    コメントを見る
                  </router-link>
                </div>
              </div>

              <p class="post-comment">{{ thank.comment }}</p>
            </div>

            <div class="post-card__aside">
              <button v-on:click="deleteThanks(thank.id)" class="danger-btn">削除</button>
            </div>
          </article>
        </div>

        <div v-else class="empty-state">
          <p class="empty-state__title">投稿はまだありません</p>
          <p class="empty-state__text">新しい投稿が作成されるとここに表示されます。</p>
        </div>

        <div v-if="next_exists" class="more-row">
          <button class="primary-btn primary-btn--wide" v-on:click="more">さらに表示</button>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "ThanksView",
  data: function() {
    return {
      thanks: [],
      page: 1,
      next_exists: true,
    }
  },
  mounted: function() {
    this.get();
  },
  methods: {
    get: async function() {
      let data = {
        page: this.page,
        max_id: "",
      };
      await axios.get("/thx_post_from_to", {params: data}).then((response) => {
        if (response.data && response.data.length == 0) {
          this.next_exists = false;
        }
        response.data.forEach(function(x) {
          if (x.is_active === true) {
            this.thanks.push(x);
          }
        }, this)
      });
    },
    deleteThanks: async function(thank_id) {
      let data = {
        thx_post_id: thank_id.toString(),
      };
      try {
        const response = await axios.post("/delete_thx_post", data);
        if (response.data.status == "OK") {
          this.thanks = this.thanks.filter(function(thank) {
            return thank.id !== thank_id;
          });
        }
      } catch (error) {
        console.error("Error deleting thank post:", error);
      }
    },
    more: function() {
      this.page++;
      this.get();
    },
    logout: function() {
      this.$store.dispatch("logout");
    }
  }
}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Noto+Sans+JP:wght@400;500;700&display=swap');

.app-wrapper {
  min-height: 100vh;
  background:
    radial-gradient(circle at top right, rgba(236, 72, 153, 0.12), transparent 26%),
    linear-gradient(180deg, #e7ecf4 0%, #dde2ec 100%);
  font-family: 'Noto Sans JP', 'Segoe UI', sans-serif;
}

.top-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 0 32px;
  min-height: 64px;
  background: #1e2a3a;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
}

.header-brand {
  display: flex;
  align-items: center;
  gap: 12px;
  min-width: 0;
}

.brand-mark {
  width: 38px;
  height: 38px;
  border-radius: 10px;
  background: linear-gradient(135deg, #4f8ef7, #7c5cfc);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.1rem;
  font-weight: 800;
  color: #fff;
  flex: 0 0 auto;
}

.brand-info {
  display: flex;
  flex-direction: column;
  line-height: 1.2;
}

.brand-name {
  font-size: 1rem;
  font-weight: 700;
  color: #fff;
}

.brand-sub {
  font-size: 0.72rem;
  color: #8a9bb0;
}

.header-actions {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
  justify-content: flex-end;
}

.back-btn,
.logout-btn {
  display: inline-flex;
  align-items: center;
  padding: 8px 16px;
  border-radius: 999px;
  border: 1.5px solid #94a3b8;
  background: transparent;
  color: #d7e0ec;
  font-size: 0.85rem;
  font-weight: 600;
  cursor: pointer;
  font-family: inherit;
  text-decoration: none;
  transition: background 0.2s ease, color 0.2s ease, transform 0.2s ease;
}

.back-btn:hover,
.logout-btn:hover {
  background: #94a3b8;
  color: #1e2a3a;
  transform: translateY(-1px);
}

.logout-btn {
  border-color: #e2e8f0;
}

.main-content {
  max-width: 980px;
  margin: 0 auto;
  padding: 40px 24px 80px;
}

.white-card {
  background: #fff;
  border-radius: 20px;
  box-shadow: 0 12px 30px rgba(15, 23, 42, 0.08);
  padding: 32px;
}

.page-head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 24px;
  padding-bottom: 16px;
  border-bottom: 1px solid #e2e8f0;
}

.page-kicker {
  margin: 0 0 6px;
  font-size: 0.78rem;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: #64748b;
}

.page-title {
  margin: 0;
  font-size: 1.35rem;
  font-weight: 700;
  color: #1e293b;
}

.page-summary {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  padding: 10px 14px;
  border-radius: 14px;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  color: #475569;
  white-space: nowrap;
}

.summary-label {
  font-size: 0.82rem;
}

.summary-value {
  min-width: 28px;
  text-align: center;
  font-size: 0.95rem;
  font-weight: 700;
  color: #0f172a;
}

.post-list {
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.post-card {
  background: linear-gradient(180deg, #f8fafc 0%, #ffffff 100%);
  border: 1px solid #e2e8f0;
  border-radius: 16px;
  padding: 16px 18px;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  gap: 16px;
  align-items: start;
}

.post-card__main {
  min-width: 0;
}

.post-card__aside {
  display: flex;
  justify-content: flex-end;
}

.post-card__head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 14px;
  margin-bottom: 8px;
}

.post-card__meta {
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 0;
}

.post-card__tools {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
  justify-content: flex-end;
}

.post-date {
  font-size: 0.8rem;
  color: #64748b;
}

.post-flow {
  font-size: 0.95rem;
  font-weight: 700;
  color: #0f172a;
}

.post-comment {
  margin: 0;
  font-size: 0.92rem;
  line-height: 1.7;
  color: #334155;
  white-space: pre-wrap;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.comment-count {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-size: 0.85rem;
  color: #475569;
}

.comment-count__label {
  font-weight: 600;
}

.comment-count__value {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 32px;
  padding: 5px 10px;
  border-radius: 999px;
  background: #e2e8f0;
  color: #334155;
  font-weight: 700;
}

.secondary-link {
  color: #2563eb;
  text-decoration: none;
  font-size: 0.88rem;
  font-weight: 700;
}

.secondary-link:hover {
  text-decoration: underline;
}

.danger-btn {
  padding: 8px 12px;
  border-radius: 10px;
  border: 1px solid #fecaca;
  background: #fff5f5;
  color: #dc2626;
  font-size: 0.82rem;
  font-weight: 700;
  cursor: pointer;
  font-family: inherit;
  transition: transform 0.18s ease, background 0.18s ease;
}

.danger-btn:hover {
  background: #fee2e2;
  transform: translateY(-1px);
}

.empty-state {
  padding: 36px 20px;
  border: 1px dashed #cbd5e1;
  border-radius: 16px;
  background: #f8fafc;
  text-align: center;
}

.empty-state__title {
  margin: 0 0 8px;
  font-size: 1rem;
  font-weight: 700;
  color: #1e293b;
}

.empty-state__text {
  margin: 0;
  color: #64748b;
  font-size: 0.9rem;
}

.more-row {
  display: flex;
  justify-content: center;
  margin-top: 22px;
}

.primary-btn {
  border: none;
  border-radius: 12px;
  background: linear-gradient(135deg, #3b82f6, #2563eb);
  color: #fff;
  font-family: inherit;
  font-size: 0.92rem;
  font-weight: 700;
  cursor: pointer;
  transition: transform 0.18s ease, box-shadow 0.18s ease;
}

.primary-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 8px 18px rgba(59, 130, 246, 0.25);
}

.primary-btn--wide {
  padding: 12px 24px;
  min-width: 180px;
}

@media (max-width: 640px) {
  .top-header {
    padding: 14px 16px;
    align-items: flex-start;
    flex-direction: column;
  }

  .white-card {
    padding: 20px 16px;
  }

  .page-head {
    flex-direction: column;
  }

  .post-card__head {
    flex-direction: column;
  }

  .post-card {
    grid-template-columns: 1fr;
  }

  .post-card__tools,
  .post-card__aside {
    justify-content: flex-start;
  }

  .danger-btn {
    width: auto;
  }
}
</style>
